module.exports = __webpack_public_path__ + "img/IMG_1209.20b8dbfa.jpg";